<template>
  <page>
    <module enable-flex>
      <m-search ref="search" @search="searchHandle">
        <c-form>
          <c-form-item type="input" label="提交人" name="nick_name"></c-form-item>
          <c-form-item type="input" label="提交人电话" name="user_manage_mobilephone"></c-form-item>
          <c-form-item type="input" label="反馈内容" name="content"></c-form-item>
          <c-form-item type="checkbox" label="反馈类型" name="type" :options="typeOptions"></c-form-item>
          <c-form-item type="checkbox" label="状态" name="state" :options="templateState"></c-form-item>
        </c-form>
      </m-search>

      <c-table ref="table">
        <c-table-column
            label="状态"
            name="state"
			width="60"
        >
          <template v-slot="{data}">
              <span v-if="data.state == 1" style="color:red;">待处理</span>
              <span v-if="data.state == 2" style="color:green;">已处理</span>
          </template>
        </c-table-column>

        <c-table-column
            label="反馈类型"
            name="type"
			width="70"
        >
            <template v-slot="{data}">
                <span v-if="data.type == 1" style="color:brown;">投诉</span>
                <span v-else-if="data.type == 2" style="color:blue;">建议</span>
                <span v-else>其他</span>
            </template>
        </c-table-column>

        <c-table-column
            label="反馈内容"
            name="content"
			width="300"
        >
        </c-table-column>

        <c-table-column
            label="反馈图片"
            name="suggestImg"
			width="100"
        >
            <template #default="{data}">
                <div v-if="data.suggestImg" class="flex-center-cross">
                    <c-image v-for="(medias, j) in  data.suggestImg.split(',')" :key="j" class="img" :src="medias" size="80" preview></c-image>
                </div>
                <span v-else>--</span>
            </template>
        </c-table-column>

        <c-table-column
            label="提交人"
            name="userManageName"
			width="100"
        >
        </c-table-column>

        <c-table-column
            label="提交人电话"
            name="userManageMobilephone"
			width="110"
        >
        </c-table-column>

        <c-table-column
            label="提交时间"
            name="createDate"
			width="140"
        >
        </c-table-column>

        <c-table-column
            type="button"
            fixed="right"
            label="操作"
            width="110"
        >
          <template v-slot="row">
            <c-table-button @click="detail(row)" power="b_member_userfeedback_detail">查看</c-table-button>
            <c-table-button @click="editHandle(row)" v-if="row.data.state == 1" power="b_member_userfeedback_edit">处理
            </c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>

    <c-dialog ref="dialog" title="处理会员反馈" width="600" height="300" @resolve="addChild">
      <c-form ref="form">
        <c-form-item type="select" label="状态：" :options="templateState" name="state" required></c-form-item>
        <c-form-item type="textarea" label="处理意见：" name="deal_suggest"></c-form-item>
      </c-form>
    </c-dialog>

    <c-dialog ref="dialog2" title="会员反馈详情" width="800" height="500" :button="false">
      <c-detail title="">
        <c-detail-item label="反馈类型：" full name="type">
            <template v-slot="{data}">
                <span v-if="detailData.type == 1" style="color:brown;">投诉</span>
                <span v-else-if="detailData.type == 2" style="color:blue;">建议</span>
                <span v-else>其他</span>
            </template>
        </c-detail-item>
        <c-detail-item label="反馈内容：" full>
          {{ detailData.content }}
        </c-detail-item>
        <c-detail-item label="图片：" full>
            <template>
                <div v-if="detailData.suggestImg" class="flex-center-cross">
                    <c-image v-for="(medias, j) in  detailData.suggestImg.split(',')" :key="j" class="img" :src="medias" size="80" preview></c-image>
                </div>
            </template>
        </c-detail-item>
        <c-detail-item label="处理意见：" full>
          {{ detailData.dealSuggest }}
        </c-detail-item>
      </c-detail>
    </c-dialog>
  </page>
</template>

<script>
var name = 'm_basicinfo_news_info';
var urls = {
  list: '/userfeedback/list', //列表数据
  del: '/news_info/del', //删除
  sort: '/news_info/sort', //排序
  detail: '/userfeedback/detail', //详情
  update: '/userfeedback/deal', //更新
}
export default {
  name: name,

  data() {
    return {
      detailData: {},
      templateState: [{
        name: '待处理',
        value: 1
      }, {
        name: '已处理',
        value: 2
      }],
      typeOptions: [{
        name: '投诉',
        value: 1
      }, {
        name: '建议',
        value: 2
      }, {
          name: '其他',
          value: 99
      }]
    }
  },

  mounted() {
    // this.$refs.table.load({
    // 	url: '/news_info/list',
    // 	// data: {
    // 	// 	parent_id: 0
    // 	// }
    // });
    this.$refs.search.search();

    this.$bus.$on(name + '.update', page => {
      this.$refs.table.update(page);
    });
  },

  methods: {
    searchHandle(data) {
      this.$refs.table.load({
        url: urls.list,
        data
      });
    },
    // loadChildren(row, resolve) {
    // 	this.request({
    // 		url: '/product_type/list',
    // 		data: {
    // 			parent_id: row.data.id
    // 		},
    // 		success: data => {
    // 			resolve(data || []);
    // 		}
    // 	});
    // },

    // addHandle(row, resolve) {
    // 	this.editState = false;
    // 	this._edit = 0;
    // 	this._parent = row ? row.data.id : 0;
    // 	this._resolve = data => {
    // 		row ? resolve(data) : this.$refs.table.push(data);
    // 	};
    // 	this.$refs.form.clear();
    // 	this.$refs.dialog.open();
    // },
    //
    editHandle(row) {
      // this.editState = true;
      this._edit = row.data.id;
      // this._resolve = data => {
      //   row.update(data);
      // };
      this.$refs.form.set({
        state: 2
      });
      this.$refs.dialog.open();
    },
    detail(row) {
      // this.editState = true;
      // this._edit = row.data.id;
      // this._resolve = data => {
      //   row.update(data);
      // };
      // this.$refs.dialog2.set(row.data);
      this.detailData = row.data;
      this.$refs.dialog2.open();
    },

    deleteHandle(row) {
      // this.request({
      // 	url: '/news_info/del',
      // 	data: {
      // 		id: row.data.id
      // 	},
      // 	loading: true,
      // 	success: data => {
      // 		this.$message({
      // 			text: '删除成功'
      // 		});
      //     this.$refs.search.search();
      // 	}
      // });
      var val = row.data;
      this.$confirm({
        text: '确定要删除【' + val.name + '】吗？',  // 提示内容,
        buttonName: '确定',  // 确定按钮文字
        cancelButton: true,  // 是否显示取消按钮
        resolve: () => {
          this.request({
            url: urls.del,
            data: {id: val.id},
            loading: true,
            success: data => {
              this.$message({
                text: '操作成功',
                icon: 'success'
              });
              this.$refs.table.update();
            }
          });
        },  // 确定按钮回调
        cancel: () => {
        },  // 取消按钮回调
      });
    },

    sortHandle(row, type, next) {
      this.request({
        url: urls.sort,
        data: {
          id: row.data.id,
          parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
          type: ['top', 'bottom'].includes(type) ? type : '',
          id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
          id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
        },
        loading: true,
        success: data => {
          next();
        }
      });
    },

    addChild(stop) {
      stop();
      var data = this.$refs.form.serialize();
      if (!data.state) {
        this.$message({
          text: '请选择状态'
        });
        return;
      }

      this.request({
        url: urls.update,
        data: Object.assign(data, {
          id: this._edit
        }),
        loading: true,
        success: data => {
          this.$message({
            text: '处理成功'
          });
          this.$refs.dialog.close();
          this.$refs.table.update();
        }
      });
    }
  }
}
</script>